import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/pipeline-monitoring/status/alert-rules')({
  beforeLoad: () => getTitleContextSlice('Alerting Rules'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
